var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { MoreHoriz } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import Menu from '../Menu';
import { useState } from 'react';
import colors from '../../themes/colors';
export default function MoreMenu(props) {
    var onClose = props.onClose, _a = props.hide, hide = _a === void 0 ? false : _a;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(null), anchor = _c[0], setAnchor = _c[1];
    var onCloseMenu = function () {
        if (onClose)
            onClose();
        setOpen(false);
    };
    var onToggleMenu = function (e) {
        setOpen(!open);
        setAnchor(open ? null : e.currentTarget);
    };
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, __assign({ sx: {
                    visibility: hide ? 'hidden' : 'visible',
                    width: 24,
                    height: 24,
                    backgroundColor: open ? colors.neutral20 : 'transparent'
                }, onClick: onToggleMenu }, { children: _jsx(MoreHoriz, { sx: { color: colors.legacy.slateBase } }) })), _jsx(Menu, __assign({}, props, { open: open, onClose: onCloseMenu, anchorEl: anchor }))] }));
}
